import { useEffect, useMemo, useState } from 'react';

export function useStableJson<T>(jsonText: string): { data: T | null; error: string | null } {
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    if (!jsonText.trim()) {
      setData(null);
      setError(null);
      return;
    }
    try {
      const parsed = JSON.parse(jsonText) as T;
      setData(parsed);
      setError(null);
    } catch {
      setData(null);
      setError('Invalid JSON');
    }
  }, [jsonText]);

  return useMemo(() => ({ data, error }), [data, error]);
}
